import moment from 'moment';
import { ReactComponent as EditIcon } from '../../../assets/images/pencil.svg';
import { ReactComponent as CloseIcon } from '../../../assets/images/close-circle.svg';
import { MRT_ColumnDef } from 'material-react-table';
import IconButton from '@mui/material/IconButton';
import { ChecklistTemplateInterface } from '../../../utils/types/checklistTemplate';

const getChecklistGridColumns = (
  onEditChecklist: (checklist: ChecklistTemplateInterface) => void,
  onDeleteChecklist: (checklist: ChecklistTemplateInterface) => void
): Array<MRT_ColumnDef<ChecklistTemplateInterface>> => [
    {
      accessorKey: 'name',
      header: 'Name'
    },
    {
      accessorKey: 'createdAt',
      header: 'Created',
      Cell: ({ cell }) => {
        const date = new Date(cell.getValue<string>());
        const humanReadableDate = moment(date).fromNow();

        return <span style={{ color: '#52659B', fontWeight: 500 }}>{humanReadableDate}</span>;
      }
    },
    {
      header: 'Actions',
      enableSorting: false,
      Cell: ({ cell }) => (
        <>
          <IconButton
            color="secondary"
            aria-label="Edit"
            onClick={() => onEditChecklist(cell.row.original)}
          >
            <EditIcon />
          </IconButton>

          <IconButton
            color="secondary"
            aria-label="Delete"
            onClick={() => onDeleteChecklist(cell.row.original)}
          >
            <CloseIcon />
          </IconButton>
        </>
      )
    }
  ];

export default getChecklistGridColumns;
